interface Props {
  /** Heading shown next to the fire icon. */
  title?: string;
  children: React.ReactNode;
}

/**
 * Brand-bordered frame used to surface boosted/recommended programs at the top of
 * a marketplace. Shared chrome only (border, glow, header) — each marketplace
 * supplies its own cards (and their layout) as children.
 */
export default function FeaturedFrame({ title = 'Recommended for you', children }: Props) {
  return (
    <section className="mx-0 mx-2 mb-6 rounded-2xl border-2 border-color-border-brand bg-color-bg-lightmode-primary px-0 px-2 pb-2 pt-4 shadow-[0px_4px_16px_0px_rgba(245,69,25,0.30)] dark:bg-color-bg-darkmode-primary sm:mx-5 sm:px-5">
      <div className="border-color-input-lightmode mb-1 flex items-center gap-2 border-b px-0 px-3 pb-2">
        <img src="/images/my-programs/fire.gif" alt="" className="h-5 w-auto" />
        <span className="typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          {title}
        </span>
      </div>
      {children}
    </section>
  );
}
